import { render, staticRenderFns } from "./CareplanModal.vue?vue&type=template&id=00054321&scoped=true&"
import script from "./CareplanModal.vue?vue&type=script&lang=js&"
export * from "./CareplanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00054321",
  null
  
)

export default component.exports